import { getStudentTextToSpeechOptions } from '../../store/selectors/sharedSelectors'

import { TEXT_TO_SPEECH_OPTIONS } from '@mission.io/mission-toolkit/constants'
import { FaMale, FaFemale } from 'react-icons/fa'

import React from 'react'
import { useSelector } from 'react-redux'
import { MultiWayToggle } from '../MultiWayToggle'

/**
 * TextToSpeechSelector - a component which allows the user to select a text to speech option for a student
 *
 * @param {Object} props - the react props
 * @param {string} props.studentId - the id fo the student to select text to speech options for
 * @param {(value: $Keys<typeof TEXT_TO_SPEECH_OPTIONS>) => any} props.onSelect - a callback used when the user selects a new option for the student
 * @param {string} props.className? - css classNames to apply to the component
 *
 * @return {React$Node}
 */
export function TextToSpeechSelector({
	studentId,
	className,
	onSelect,
}: {
	studentId: string,
	onSelect: (value: $Keys<typeof TEXT_TO_SPEECH_OPTIONS>) => any,
	className?: string,
}): React$Node {
	const textToSpeech = useSelector(state => getStudentTextToSpeechOptions(state, studentId))

	return (
		<MultiWayToggle
			options={[
				{
					value: TEXT_TO_SPEECH_OPTIONS.OFF,
					label: 'off',
					ariaLabel: 'disallow text-to-speech',
				},
				{
					value: TEXT_TO_SPEECH_OPTIONS.MALE,
					label: <FaMale title="allow use of dictation using a male voice reader" />,
					ariaLabel: 'text-to-speech with male voice',
				},
				{
					value: TEXT_TO_SPEECH_OPTIONS.FEMALE,
					label: <FaFemale title="allow use of dictation using a female voice reader" />,
					ariaLabel: 'text-to-speech with female voice',
				},
			]}
			onSelectOption={onSelect}
			selectedOption={textToSpeech}
			className={className}
		/>
	)
}
